import React, {Component} from "react";
import {withRouter} from "react-router-dom";
import CRPHeader from "../CRPHeader/CRPHeader";
import CRPFooter from "../CRPFooter/CRPFooter";
import CRPMainLayout from "../CRPMainLayout/CRPMainLayout";
import {browserInfoText, URLS, QUERY} from "../../constants";
import CrpCookieFooter from "../CRPCookieFooter/CRPCookieFooter";

class CRPContainer extends Component {
    state = {
        route: null,
        hideInfoMessage: false,
    };

    name = (route) => {
        this.setState({route});
    };

    render() {
        const pathname = this.props.history.location.pathname;

        const source = new URLSearchParams(this.props.history.location.search).get(
            QUERY.source
        );
        const reference = new URLSearchParams(
            this.props.history.location.search
        ).get(QUERY.reference);

        if (pathname.split("/").pop() === URLS.CRP) {
            this.props.history.push(URLS.HOME);
        }

        return (
            <div className="tenderBackground">
                {window.navigator.userAgent.indexOf("MSIE") > -1 && (
                    <div className="infoMessageDiv" hidden={this.state.hideInfoMessage}>
                        <p className="infoMessage">{browserInfoText}</p>
                        <a>
                            <i
                                onClick={() => this.setState({hideInfoMessage: true})}
                                className="fa fa-times-circle-o infoMessageCloseButton"
                                aria-hidden="true"
                            />
                        </a>
                    </div>
                )}

                {source || reference ? null : (
                    <CRPHeader
                        route={this.state.route}
                        currentRoute={pathname.split("/").pop()}
                        changeMenuSelection={this.changeMenuSelection}
                    />
                )}

                <CRPMainLayout
                    changeMenuSelection={this.changeMenuSelection}
                    name={this.name}
                    hideMargin={source || reference ? true : false}
                />

                {!pathname.includes("RegistrationSuccess") && <CRPFooter/>}

                {!(source || reference) && (
                    <CrpCookieFooter/>
                )}
            </div>
        );
    }
}

export default withRouter(CRPContainer);
